import React from 'react';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import OrderComponent from "./OrderComponent";
import "bootstrap/dist/css/bootstrap.min.css";


function App() {

  return (
    <div>
      <Router>
        <Switch>
          <Route path="/visualizations/:ref">
            <OrderComponent />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
